import React from 'react';
import { Link } from 'react-router';

import Container from '../Container';
import ExternalLink from '../ExternalLink';
import FooterInfo from './components/FooterInfo';
import FooterNav from './components/FooterNav';
import Logo from '../Logo';

import { hideBelowMD, srOnly } from './../../base-styles/mixins.module.css';
import {
  about,
  container,
  copyright,
  footer,
  getInTouch,
  getInTouchLink,
  hr,
  lists,
  logo,
  social,
  socialIcon,
  socialSection,
  logoSection,
  smallPrint,
} from './styles.module.css';

/**
 * Footer presentational component.
 */
const Footer = () => (
  <footer className={footer} role="contentinfo">
    <Container className={container}>
      <div className={logoSection}>
        <Logo inverse className={logo} />
        <div className={getInTouch}>
          Want to see your event listed? <a className={getInTouchLink} href="/organisers/">Get in touch</a>
        </div>
        <div className={about}>
          <Link to="/about">About Us</Link>
        </div>
      </div>

      <div className={lists}>
        <FooterInfo>
          <FooterNav title="All Events" to="/all-events">
            <Link to="/road-cycling-events">{'Road Cycling'}</Link>
            <Link to="/obstacle-course-events">{'Obstacle Racing'}</Link>
            <Link to="/swimming-events">{'Swimming'}</Link>
            <Link to="/duathlon-events">{'Duathlon'}</Link>
            <Link to="/swimrun-events">{'Swimrun'}</Link>
          </FooterNav>
        </FooterInfo>

        <FooterInfo>
          <FooterNav title="Running" to="/running-events">
            <Link to="/running-events/5k">{'5k'}</Link>
            <Link to="/running-events/10k">{'10k'}</Link>
            <Link to="/running-events/half-marathon">{'Half Marathon'}</Link>
            <Link to="/running-events/marathon">{'Marathon'}</Link>
            <Link to="/running-events/ultramarathon">{'Ultramarathon'}</Link>
          </FooterNav>
        </FooterInfo>

        <FooterInfo>
          <FooterNav title="Triathlon" to="/triathlon-events">
            <Link to="/triathlon-events/super-sprint">{'Super sprint'}</Link>
            <Link to="/triathlon-events/sprint">{'Sprint'}</Link>
            <Link to="/triathlon-events/olympic">{'Olympic'}</Link>
            <Link to="/triathlon-events/half-ironman">{'Half Ironman'}</Link>
            <Link to="/triathlon-events/ironman">{'Ironman'}</Link>
          </FooterNav>
        </FooterInfo>
      </div>

      <FooterInfo className={socialSection}>
        <ul className={social}>
          <li>
            <ExternalLink href="https://www.facebook.com/letsdothisuk" className={socialIcon}>
              <i className="fa fa-facebook-square fa-2x" aria-hidden="true" />
              <span className={srOnly}>{'Facebook'}</span>
            </ExternalLink>
          </li>
          <li>
            <ExternalLink href="https://twitter.com/letsdothisrace" className={socialIcon}>
              <i className="fa fa-twitter fa-2x" aria-hidden="true" />
              <span className={srOnly}>{'Twitter'}</span>
            </ExternalLink>
          </li>
          <li>
            <ExternalLink href="https://www.instagram.com/letsdothis.com_" className={socialIcon}>
              <i className="fa fa-instagram fa-2x" aria-hidden="true" />
              <span className={srOnly}>{'Instagram'}</span>
            </ExternalLink>
          </li>
        </ul>
      </FooterInfo>
    </Container>

    <hr className={hr} />

    <Container className={smallPrint}>
      <FooterInfo className={copyright}>
        © Copyright Let’s Do This {new Date().getFullYear()}
      </FooterInfo>

      <FooterInfo className={hideBelowMD}>
        <Link to="/privacy">Privacy</Link>
      </FooterInfo>

      <FooterInfo className={hideBelowMD}>
        <Link to="/terms">Terms</Link>
      </FooterInfo>
    </Container>
  </footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./app/src/components/Footer/index.jsx